<template>

  <el-dialog :show-close="true" :title="dialogTitle" :visible="dialogVisible" @close="bntClick(null)">
    <el-form :model="appDate">
      <el-form-item label="应用名称" :label-width="formLabelWidth">
        <el-input v-model="appDate.appName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="应用包名" :label-width="formLabelWidth">
        <el-input v-model="appDate.packageName" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="应用简介" :label-width="formLabelWidth">
        <el-input v-model="appDate.appDesc" autocomplete="off"></el-input>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="bntClick(null)">取 消</el-button>
      <el-button type="primary" @click="bntClick(appDate)">确 定</el-button>
    </div>
  </el-dialog>

</template>

<script>

import toastUtils from "@/utils/toastUtils";

export default {
  name: "createAppDialog",
  //完整接收props参数
  props: {
    dialogVisible: {
      type: Boolean,
      default: false //默认值
      // required:true //是必要的
    },
    dialogShowType: {
      type: Number,
      default: 1
    },
    appDate: {
      type: Object,
      required: true
    }
  },
  methods: {
    bntClick(value) {
      ///value === null表示取消和关闭按钮
      if (value === null) {
        this.$emit('creatAppClick', value, this.dialogShowType)
        return;
      }
      if (!value.appName) {
        toastUtils.warning(this, "应用名称不能为空")
        return;
      }

      if (!value.packageName) {
        toastUtils.warning(this, "应用包名不能为空")
        return;
      }
      this.$emit('creatAppClick', value, this.dialogShowType)
    }
  },
  data() {
    return {
      formLabelWidth: '120px'
    }
  },
  computed: {
    dialogTitle() {
      switch (this.dialogShowType) {
        case 1:
          return '创建应用';
        case 2:
          return '更新应用';
        default:
          return '创建应用';
      }
    }
  }

}
</script>

<style scoped>

</style>